// extracted by mini-css-extract-plugin
export default {"burger_menu":"BurgerMenu_burger_menu__4Awpt","close":"BurgerMenu_close__RWkON","mainNavLink":"BurgerMenu_mainNavLink__KWHAU","navLink":"BurgerMenu_navLink__E3pXI"};